module.exports = __webpack_public_path__ + "static/img/icon1.b941220b.png";